export { messageStore as store } from './store'



// WEBPACK FOOTER //
// ./src/message/index.js